import React from 'react';
import styled from 'styled-components';
import { Cell } from './Cell';
import { DataType, TableType } from './types';
import { theme } from '../../theme';
import { BaseUITextStyles, StyledUITextProps } from '../typography';
import { getCellContent, getCellHref, getCellOnClick } from './utils';
import { Alignment } from '../../types';

export type TableProps = TableType & {
  showHeaderRow?: boolean;
};

type CellProps = {
  align?: Alignment;
};

const StyledTable = styled.table`
  border-spacing: 0;
  width: 100%;
`;

const Head = styled.th<StyledUITextProps & CellProps>`
  ${BaseUITextStyles};
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  padding: ${theme.spacings[3].rem} 0;
  font-weight: 700;
  text-align: ${({ align }) => align};
`;

const CellWrapper = styled.td<CellProps>`
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  padding: ${theme.spacings[3].rem} 0;
  text-align: ${({ align }) => align};
  vertical-align: top;
`;

const getAlignment = (type: DataType) => {
  return type === 'currency' || type === 'number' ? 'right' : 'left';
};

export const Table: React.FC<TableProps> = ({
  columnData,
  data,
  showHeaderRow = true,
}) => {
  return (
    <StyledTable>
      {showHeaderRow && (
        <thead>
          <tr>
            {columnData.map(
              ({
                label,
                settings: {
                  large: { showLabel = true },
                },
                type,
              }) => {
                return (
                  <Head key={label} align={getAlignment(type)} size="md">
                    {showLabel && label}
                  </Head>
                );
              }
            )}
          </tr>
        </thead>
      )}
      <tbody>
        {data.map((row, j) => (
          <tr key={j}>
            {columnData.map(({ key, isBold, type }) => {
              const cell = row[key];
              return (
                <CellWrapper align={getAlignment(type)} key={key}>
                  <Cell
                    content={getCellContent(cell)}
                    href={getCellHref(cell)}
                    onClick={getCellOnClick(cell)}
                    isBold={isBold}
                    type={type}
                  />
                </CellWrapper>
              );
            })}
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
};
